import { render, staticRenderFns } from "./productBaseInfo.vue?vue&type=template&id=7f1e3f6a&scoped=true"
import script from "./productBaseInfo.vue?vue&type=script&lang=js"
export * from "./productBaseInfo.vue?vue&type=script&lang=js"
import style0 from "./productBaseInfo.vue?vue&type=style&index=0&id=7f1e3f6a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1e3f6a",
  null
  
)

export default component.exports